var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: "woocommerce-" + _vm.formName + "-fields",
      attrs: { id: _vm.formName + "-form" }
    },
    [
      _c("div", { attrs: { id: "registration-form-errors" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.hasErrors,
                expression: "hasErrors"
              }
            ],
            staticClass: "registration-form-errors woocommerce-error"
          },
          [
            _vm._v(
              "\n      " + _vm._s(_vm.$modeoL10n.errors_in_form) + "\n    "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _vm.serverErrorMessage
        ? _c("div", {
            domProps: {
              innerHTML: _vm._s(_vm.$sanitize(_vm.serverErrorMessage))
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { class: "woocommerce-" + _vm.formName + "-fields__field-wrapper" },
        _vm._l(_vm.formFields, function(field, key) {
          return _c(
            "div",
            {
              key: key,
              staticClass: "form-row",
              class: field.class.join(" "),
              attrs: { id: key + "_field" }
            },
            [
              _c(
                "label",
                {
                  class: { "form-label-has-error": _vm.errors.has(key) },
                  attrs: { for: key }
                },
                [
                  _vm._v(_vm._s(field.label) + "\n        "),
                  field.required
                    ? _c(
                        "abbr",
                        {
                          staticClass: "required",
                          attrs: { title: "vaaditaan" }
                        },
                        [_vm._v("*")]
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              field.type == "country"
                ? [
                    _c("strong", [_vm._v(_vm._s(_vm.$modeoL10n.finland))]),
                    _vm._v(" "),
                    _c("input", {
                      attrs: { id: key, type: "hidden", name: key, value: "FI" }
                    })
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.getType(field) === "checkbox" && field.type != "country"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.address[_vm.getIndex(key)],
                        expression: "address[getIndex(key)]"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.getValidations(field, key),
                        expression: "getValidations(field, key)"
                      }
                    ],
                    staticClass: "input-text",
                    class: { "form-field-has-error": _vm.errors.has(key) },
                    attrs: {
                      id: key,
                      name: key,
                      placeholder: "",
                      autocomplete: field.autocomplete,
                      disabled: key == _vm.formName + "_country",
                      type: "checkbox"
                    },
                    domProps: {
                      checked: Array.isArray(_vm.address[_vm.getIndex(key)])
                        ? _vm._i(_vm.address[_vm.getIndex(key)], null) > -1
                        : _vm.address[_vm.getIndex(key)]
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a = _vm.address[_vm.getIndex(key)],
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.address,
                                  _vm.getIndex(key),
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.address,
                                  _vm.getIndex(key),
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.address, _vm.getIndex(key), $$c)
                          }
                        },
                        function($event) {
                          return _vm.formChanged()
                        }
                      ],
                      blur: function($event) {
                        return _vm.fieldFocusOut(key)
                      }
                    }
                  })
                : _vm.getType(field) === "radio" && field.type != "country"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.address[_vm.getIndex(key)],
                        expression: "address[getIndex(key)]"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.getValidations(field, key),
                        expression: "getValidations(field, key)"
                      }
                    ],
                    staticClass: "input-text",
                    class: { "form-field-has-error": _vm.errors.has(key) },
                    attrs: {
                      id: key,
                      name: key,
                      placeholder: "",
                      autocomplete: field.autocomplete,
                      disabled: key == _vm.formName + "_country",
                      type: "radio"
                    },
                    domProps: {
                      checked: _vm._q(_vm.address[_vm.getIndex(key)], null)
                    },
                    on: {
                      change: [
                        function($event) {
                          _vm.$set(_vm.address, _vm.getIndex(key), null)
                        },
                        function($event) {
                          return _vm.formChanged()
                        }
                      ],
                      blur: function($event) {
                        return _vm.fieldFocusOut(key)
                      }
                    }
                  })
                : field.type != "country"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.address[_vm.getIndex(key)],
                        expression: "address[getIndex(key)]"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.getValidations(field, key),
                        expression: "getValidations(field, key)"
                      }
                    ],
                    staticClass: "input-text",
                    class: { "form-field-has-error": _vm.errors.has(key) },
                    attrs: {
                      id: key,
                      name: key,
                      placeholder: "",
                      autocomplete: field.autocomplete,
                      disabled: key == _vm.formName + "_country",
                      type: _vm.getType(field)
                    },
                    domProps: { value: _vm.address[_vm.getIndex(key)] },
                    on: {
                      change: function($event) {
                        return _vm.formChanged()
                      },
                      blur: function($event) {
                        return _vm.fieldFocusOut(key)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.address,
                          _vm.getIndex(key),
                          $event.target.value
                        )
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.errors.has(key)
                ? _c("span", { staticClass: "form-field-error-message" }, [
                    _vm._v(_vm._s(_vm.errors.first(key)))
                  ])
                : _vm._e()
            ],
            2
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "form-footer" }, [
        _c("input", {
          attrs: {
            id: "woocommerce-register-nonce",
            type: "hidden",
            name: "woocommerce-register-nonce"
          },
          domProps: { value: _vm.nonce }
        }),
        _vm._v(" "),
        _c("input", {
          attrs: {
            type: "hidden",
            name: "_wp_http_referer",
            value: "/rekisteroidy/"
          }
        }),
        _vm._v(" "),
        _c("input", {
          staticClass: "woocommerce-Button button btn btn--block",
          attrs: { type: "submit", name: "register" },
          domProps: { value: _vm.$modeoL10n.register },
          on: {
            click: function($event) {
              return _vm.submit($event)
            }
          }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "form-disclaimer" }, [
          _vm._v(
            "\n      " + _vm._s(_vm.$modeoL10n.asterisk_explanation) + "\n    "
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "form-footer__link" }, [
          _vm._v("\n      " + _vm._s(_vm.$modeoL10n.already_an_account) + " "),
          _c("a", { attrs: { href: _vm.$modeoL10n.url_myaccount } }, [
            _vm._v(_vm._s(_vm.$modeoL10n.log_in) + "!")
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a039910", { render: render, staticRenderFns: staticRenderFns })
  }
}